/**
 * Shared responsive breakpoints — the CSS-side single source of truth
 * (2026-08-03 desktop-polish pass). Values mirror src/hooks/useResponsive.ts
 * exactly; keep the two in lockstep or styled-components and JS hooks will
 * disagree about which breakpoint is active.
 *
 * Usage (mobile-first, min-width only):
 *   const Card = styled.div`
 *     padding: 1.25rem;
 *     ${media.tablet} { padding: 1.5rem; }
 *     ${media.laptop} { padding: 1.75rem; }
 *   `;
 */

export const BREAKPOINTS = {
  tablet: 768,
  laptop: 1024,
  desktop: 1200,
} as const;

export const media = {
  tablet: `@media (min-width: ${BREAKPOINTS.tablet}px)`,
  laptop: `@media (min-width: ${BREAKPOINTS.laptop}px)`,
  desktop: `@media (min-width: ${BREAKPOINTS.desktop}px)`,
} as const;
